export default {
  name: "ስም",
  tel: "ስልክ",
  save: "አስቀምጥ",
  confirm: "አረጋግጥ",
  cancel: "ይቅር",
  delete: "ሰርዝ",
  complete: "ጨርስ",
  loading: "በመጫን ላይ ...",
  telEmpty: "እባክዎን የስልክ ቁጥርዎን ይሙሉ",
  nameEmpty: "እባክዎን ስምዎን ይሙሉ",
  nameInvalid: "እባክዎን ትክክለኛ ስም ያስገቡ",
  confirmDelete: "እርግጠኛ ነዎት ሊሰርዙት ይፈልጋሉ?",
  telInvalid: "እባክዎ ትክክለኛውን የስልክ ቁጥር ያስገቡ",
  vanCalendar: {
    end: "ጨርስ",
    start: "ጀምር",
    title: "ርዕስ",
    confirm: "አረጋግጥ",
    startEnd: "መጨረሻ ይጀምሩ",
    weekdays: {
      "0": "ቀን",
      "1": "አንድ",
      "2": "ሁለት",
      "3": "ሶስት",
      "4": "አራት",
      "5": "አምስት",
      "6": "ስድስት"
    }
  },
  vanCascader: { select: "እባክዎን ይምረጡ" },
  vanContactCard: { addText: "አንድ ዕውቂያ ያክሉ" },
  vanContactList: { addText: "አዲስ የእውቂያ ሰው" },
  vanPagination: { prev: "ቀዳሚ ገጽ", next: "ቀጣይ ገጽ" },
  vanPullRefresh: { pulling: "ለማደስ ወደታች ይጎትቱ ...", loosing: "መልቀቅ አድስ ..." },
  vanSubmitBar: { label: "ሁሉም" },
  vanCoupon: { unlimited: "ምንም የአጠቃቀም ገደቦች የሉም" },
  vanCouponCell: { title: "ኩፖኖች", tips: "አይገኝም" },
  vanCouponList: {
    empty: "ምንም ኩፖኖች የሉም",
    exchange: "ልውውጥ",
    close: "ምንም ኩፖኖች የሉም",
    enable: "ይገኛል",
    disabled: "አይገኝም",
    placeholder: "እባክዎ የቅናሽ ኮዱን ያስገቡ"
  },
  vanAddressEdit: {
    area: "አካባቢ",
    postal: "የፖስታ መላኪያ ኮድ",
    areaEmpty: "አንድ ክልል ይምረጡ",
    addressEmpty: "ዝርዝር አድራሻውን ይሙሉ",
    postalEmpty: "የፖስታ ኮድ ቅርጸት የተሳሳተ ነው",
    defaultAddress: "እንደ ነባሪው የመላኪያ አድራሻ ያዘጋጁ",
    telPlaceholder: "የተንቀሳቃሽ ስልክ ቁጥር",
    namePlaceholder: "የተዋዋይ ስም",
    areaPlaceholder: "አንድ አውራጃ / ከተማ / ዲስትሪክት ይምረጡ"
  },
  vanAddressEditDetail: {
    label: "አድራሻ",
    placeholder: "የጎዳና በር ቁጥር, የወለል ክፍል ቁጥር እና ሌሎች መረጃዎች"
  },
  vanAddressList: { add: "አድራሻ ያክሉ" }
};
